import { AfterViewInit, EventEmitter, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Component, Input } from '@angular/core';
import { StateManager } from '@app/modules/shared/managers/state.manager';

@Component({
	selector: 'calendar-input-filter-component',
	templateUrl: 'input-filter.component.html',
	styleUrls: ['./input-filter.component.scss'],
})
export class CalendarInputFilterComponent implements OnInit, OnChanges, AfterViewInit {
	@Input() public type: string = 'text';
	@Input() public translationKey: string;
	@Input() public default: string;
	@Output() public readonly filter: EventEmitter<string> = new EventEmitter();

	public valueIsValid: boolean = true;
	public id: string;

	constructor(private readonly stateManager: StateManager) {}

	public ngOnChanges(changes: SimpleChanges): void {
		if (
			(changes.default?.currentValue || changes.default?.previousValue) &&
			changes.default?.isFirstChange() === false
		) {
			this.filterData(this.default || '');
			this.ngAfterViewInit();
		}
	}

	public ngOnInit(): void {
		this.id = `input-filter-${Math.random().toString()}`;
		if (this.default) {
			this.filterData(this.default);
		}
	}

	public ngAfterViewInit(): void {
		const state: string = this.stateManager.getState('calendar-input-filter');
		if (state || state === '') {
			(document.getElementById(this.id) as HTMLInputElement).value = state;
		}
	}

	public onValueChange(_value: string): void {
		if (_value.length === 0) {
			this.filter.emit(_value);
			return;
		}
	}

	public filterData(_value: string): void {
		this.stateManager.setState('calendar-input-filter', _value);
		this.filter.emit(_value);
	}
}
